import { IJobOpening } from "@/shared/api/employment"
import { useAppDispatch } from "@/shared/lib/redux"
import { 
    openCreateVacancyModal as openCreateVacancyModalAction, 
    openDeleteVacancyModal as openDeleteVacancyModalAction, 
    openUpdateVacancyModal as openUpdateVacancyModalAction,
    closeCreateVacancyModal as closeCreateVacancyModalAction,
    closeUpdateVacancyModal as closeUpdateVacancyModalAction,
    closeDeleteVacancyModal as closeDeleteVacancyModalAction,
    openEditVacancyFormModal as openEditVacancyFormModalAction
} from "../../model"

export const useUpdateVacancyModal = () => {
    const dispatch = useAppDispatch()

    const openCreateVacancyModal = (onSuccess?: () => void) => {
        dispatch(openCreateVacancyModalAction({
            onSuccess
        }))
    }

    const openEditVacancyFormModal = (data: IJobOpening, onSuccess?: () => void) => {
        dispatch(openEditVacancyFormModalAction({
            data,
            onSuccess
        }))
    }

    const openDeleteVacancyModal = (data: IJobOpening, onSuccess?: () => void) => {
        dispatch(openDeleteVacancyModalAction({
            data,
            onSuccess
        }))
    }

    const openUpdateVacancyModal = (data: IJobOpening, onSuccess?: () => void) => {
        dispatch(openUpdateVacancyModalAction({
            data,
            onSuccess
        }))
    }

    const closeUpdateVacancyModal = () => {
        dispatch(closeUpdateVacancyModalAction())
    }

    const closeDeleteVacancyModal = () => {
        dispatch(closeDeleteVacancyModalAction())
    }

    const closeCreateVacancyModal = () => {
        dispatch(closeCreateVacancyModalAction())
    }
    
    return {
        closeCreateVacancyModal,
        closeUpdateVacancyModal,
        closeDeleteVacancyModal,
        openCreateVacancyModal,
        openDeleteVacancyModal,
        openUpdateVacancyModal,
        openEditVacancyFormModal
    }
}